var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ACol',_vm._b({},'ACol',_vm.columnConfig,false),[(_vm.term || _vm.$slots.term)?_c('div',{class:_vm.genCls('term')},[_vm._t("term",function(){return [_vm._v(_vm._s(_vm.term))]})],2):_vm._e(),_c('div',{class:_vm.genCls('detail')},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }